import { c as _c } from "react/compiler-runtime";
import { useChains } from "@opensea/app-kit";
import { useCallback } from "react";
import { useAddress } from "../../polychain/hooks/useAddress";
import { useRequireChain } from "../../polychain/hooks/useRequireChain";
import { useTrackError } from "../../providers/TrackErrorProvider";
import { FlowActions } from "../../stores/flowStore";
import { useConnectFlow } from "./useConnectFlow";
export const useCreateCollectionOfferFlow = () => {
  const $ = _c(6);
  const address = useAddress();
  const connect = useConnectFlow();
  const {
    getChainId
  } = useChains();
  const {
    requireChain
  } = useRequireChain();
  const trackError = useTrackError();
  let t0;
  if ($[0] !== address || $[1] !== connect || $[2] !== getChainId || $[3] !== requireChain || $[4] !== trackError) {
    t0 = (slug, t1) => {
      const {
        trait,
        traits,
        initialPrice,
        chain
      } = t1 === undefined ? {} : t1;
      const openCreateCollectionOfferFlow = async () => {
        if (chain) {
          ;
          try {
            await requireChain(getChainId(chain));
          } catch (t2) {
            const error = t2;
            trackError(error);
          }
        }
        FlowActions.startFlow({
          type: "create-collection-offer",
          slug,
          trait,
          traits,
          initialPrice
        });
      };
      if (address) {
        openCreateCollectionOfferFlow();
      } else {
        connect({
          onConnected: openCreateCollectionOfferFlow
        });
      }
    };
    $[0] = address;
    $[1] = connect;
    $[2] = getChainId;
    $[3] = requireChain;
    $[4] = trackError;
    $[5] = t0;
  } else {
    t0 = $[5];
  }
  return t0;
};